import { EServiceId } from '../../../../redux/reducers';
import { IPublishTermsResponse, ITermSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getServiceId } from '../../../../utils/publishTerms';

const SERVICE_ORDER = [EServiceId.top, EServiceId.premium, EServiceId.paid, EServiceId.free];

export function getServices(response: IPublishTermsResponse): ITermSchema[] {
  const { terms } = response;

  if (!terms) {
    return [];
  }

  return SERVICE_ORDER.reduce((acc, serviceId) => {
    const term = terms.find(term => getServiceId(term.services) === serviceId);

    if (term) {
      acc.push(term);
    }

    return acc;
  }, [] as ITermSchema[]);
}
